// DS: DEV13
import React, { useCallback } from 'react';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useFirstTimeFlag } from '../../../redux/firstTimeFlags/hooks';
import { usePopoverOnInteraction } from '@wix/da-ds/pkg/popper/hooks/usePopoverOnInteraction';
import SophisticatedTooltipBase, {
  SophisticatedTooltipBaseProps,
} from '@wix/da-ds/pkg/tooltips/lego/SophisticatedTooltipBase';

type Props = Exclude<
  SophisticatedTooltipBaseProps,
  'onReferenceClick' | 'onReferenceMouseEnter' | 'onReferenceMouseLeave'
> & {
  /**
   * The FTUE flag this tooltip will need to reference.
   * All selecting/dropping of the flag from the store is handled by this component
   */
  flag: FirstTimeFlag;
  enabled?: boolean;
};

/**
 * A SophisticatedTooltip with the UX we expect for an FTUE tooltip.
 *
 * If `heading` isn't supplied, `aria-label` is required to fulfill a11y requirements.
 */
const SophisticatedFtueTooltip: React.FC<Props> = ({
  isVisible,
  flag,
  enabled = true,
  onClose: consumerProvidedOnClose,
  ...rest
}) => {
  const { hasFlag, dropFlag } = useFirstTimeFlag(flag);
  const { onClick, onMouseEnter, onMouseLeave, onClose } =
    usePopoverOnInteraction({ listenOnClicks: true, listenOnHover: true });

  const handleClose = useCallback(() => {
    onClose();
    dropFlag();
    if (consumerProvidedOnClose) {
      consumerProvidedOnClose();
    }
  }, [onClose, dropFlag, consumerProvidedOnClose]);

  return (
    <SophisticatedTooltipBase
      isVisible={!!hasFlag && enabled}
      onReferenceClick={onClick}
      onReferenceMouseEnter={onMouseEnter}
      onReferenceMouseLeave={onMouseLeave}
      onClose={handleClose}
      {...(rest as any)}
    />
  );
};
SophisticatedFtueTooltip.displayName = 'SophisticatedFtueTooltip';

export default SophisticatedFtueTooltip;
